import { roleService } from '@/api';
import { RoleResource } from '@/resource/model';
import { messageError, translation } from '@/utils';
import { Form, Message } from 'element-ui';
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';

@Component({
  name: 'add-role'
})
export default class AddRole extends Vue {
  /**
   * 控制dialog的显示隐藏，默认为false(不显示)
   */
  @PropSync('visible', { default: false }) public syncedVisible!: boolean;
  @Prop({
    required: false,
    default: () => {
      return null;
    },
    type: Object
  })
  public role!: RoleResource | null;

  public title = 'role.addRole';

  public roleForm: {
    roleName: string;
    remark: string;
  } = {
    roleName: '',
    remark: ''
  };

  public roleFormRules = {
    roleName: [
      {
        required: true,
        validator: (rule: any, value: string, callback: Function): void => {
          if (!value) {
            callback(new Error(translation('role.nameEmpty')));
            return;
          }
          callback();
        },
        trigger: 'blur'
      },
      {
        validator: (rule: any, value: string, callback: Function): void => {
          roleService
            .checkRoleName(value, this.role?.id)
            .then((isRepeat: boolean) => {
              if (isRepeat) {
                callback(translation('requestError.roleNameRepeat'));
                return;
              }
              callback();
            })
            .catch(error => {
              callback(error);
            });
        },
        trigger: 'blur'
      }
    ]
  };
  public submitLoading = false;
  private operationType: 'add' | 'edit' = 'add';

  public dialogOpen(): void {
    if (!this.role) {
      this.operationType = 'add';
      this.title = 'role.addRole';
      return;
    }
    this.operationType = 'edit';
    this.title = 'role.editRole';
    this.$nextTick(() => {
      Object.assign(this.roleForm, this.role);
    });
  }

  /**
   * Dialog 关闭动画结束时的回调
   */
  public dialogClosed(): void {
    this.$emit('dialog-closed');
    (this.$refs.roleForm as Form).resetFields();
  }

  public onSubmit(): void {
    (this.$refs.roleForm as Form).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      this.setLoading(true);
      try {
        if (this.operationType === 'add') {
          await roleService.post({ ...this.roleForm } as any);
          Message.success(translation('operationRes.addSuccess'));
          this.$emit('add-success');
          this.closeDialog();
          return;
        }
        await roleService.put({ ...this.roleForm } as any);
        Message.success(translation('operationRes.editSuccess'));
        this.$emit('edit-success', this.roleForm);
        this.closeDialog();
      } catch (error) {
        messageError(error);
      } finally {
        this.setLoading(false);
      }
    });
  }

  private setLoading(value: boolean): void {
    this.submitLoading = value;
  }

  private closeDialog(): void {
    this.syncedVisible = false;
  }
}
